

module.exports = __webpack_require__.stylable.create(
    "DemoContentNotification1617024716",
    {"classes":{"root":"DemoContentNotification1617024716__root","text":"DemoContentNotification1617024716__text","icon":"DemoContentNotification1617024716__icon"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    "DemoContentNotification1617024716",
    null
);
